import React from 'react';
import { H1, Details, Content as ContentContainer } from '@core';
import { ResourceLinks } from '@content';
import { HeaderGradient } from '@components';

export const RenewableResourcesLinks = () => {
  return (
    <>
      <div className="mt-20 desktop:mt-28" />
      <HeaderGradient
        leftColor="from-general-darkblue"
        rightColor="to-general-red"
        title={ResourceLinks.pageTitle}
      />
      <ContentContainer>
        <div className="flex laptop:flex-row phone:flex-col">
          <div className="w-full flex flex-col tablet:flex-row items-center">
            <section className="w-full">
              <H1 className="text-blue mb-5">{ResourceLinks.title}</H1>
              {ResourceLinks.contents.map((content) => {
                return (
                  <>
                    <Details>
                      {content.title} <br />
                      <a
                        className="text-orange"
                        href={content.link}
                        rel="noreferrer"
                        target="_blank"
                      >
                        {content.anchor}
                      </a>
                    </Details>
                  </>
                );
              })}
            </section>
          </div>
        </div>
      </ContentContainer>
      <div className="desktop:h-18 desktopWide:h-1/3 w-full">&nbsp;</div>
    </>
  );
};
